import React from "react";

/*
 * Circular-arrow ±10s glyphs from the Class Page reference — a rotate arrow
 * with the numeral inside, used across the player card, mini-player, and
 * expanded sheet.
 */

export const RotateBackGlyph = ({ size = 24 }) => (
  <span className="relative inline-flex" style={{ width: size, height: size }}>
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M4 3v5h5" />
      <path d="M4.3 8a10 10 0 1 1-1.3 6" />
    </svg>
    <span className="absolute inset-0 flex items-center justify-center font-extrabold" style={{ fontSize: Math.round(size / 3), paddingTop: 3 }}>
      10
    </span>
  </span>
);

export const RotateForwardGlyph = ({ size = 24 }) => (
  <span className="relative inline-flex" style={{ width: size, height: size }}>
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M20 3v5h-5" />
      <path d="M19.7 8a10 10 0 1 0 1.3 6" />
    </svg>
    <span className="absolute inset-0 flex items-center justify-center font-extrabold" style={{ fontSize: Math.round(size / 3), paddingTop: 3 }}>
      10
    </span>
  </span>
);
